import { Fragment } from 'react'
const HeaderSection = props => {
    const bgColor = props.bgColor || "bg-gray-100";
    const textColor = props.textColor || "text-dark dark:text-white";

    return <Fragment>
        <div className=" flex flex-wrap">
            <div className={`w-full px-4 ${bgColor}`}>
                <div className="max-w-2xl mx-auto p-10 text-center">
                    <h2 className={`mb-3 text-3xl font-bold leading-[1.2] ${textColor} sm:text-4xl md:text-[40px]`}>
                        {props.title}
                    </h2>

                </div>
            </div>
        </div>
    </Fragment >
}
export default HeaderSection;